import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { fromTiptapLinkConverter } from "./../_shared/link/link-converters.js";
const linkPreviewConverter = {
  toPm: {
    types: [Node_Type.LINK_PREVIEW],
    // @ts-expect-error next node type
    convert: (node) => ({
      type: Node_Type.LINK_PREVIEW,
      attrs: {
        ...node.linkPreviewData,
        id: node.id
      }
    })
  },
  fromPm: {
    types: [Node_Type.LINK_PREVIEW],
    // @ts-expect-error next node type
    convert: (node) => {
      const { id, ...data } = node.attrs || {};
      if (node?.attrs?.error || node?.attrs?.loading) {
        return void 0;
      }
      return {
        type: Node_Type.LINK_PREVIEW,
        id,
        nodes: [],
        linkPreviewData: {
          ...data,
          link: fromTiptapLinkConverter(data.link)
        }
      };
    }
  }
};
export {
  linkPreviewConverter
};
//# sourceMappingURL=link-preview-converter.js.map
